module.exports = __webpack_public_path__ + "static/img/苏德勇总经理.9116cac4.png";